import { lazy, Suspense } from 'react';
import { AuthGuard } from '@emfood/shared';
import { Outlet, createRoute } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { paths } from '../paths';
import { rootRoute } from './root';

const SeasonalCalendar = lazy(() => import('src/sections/seasonal-calendar/seasonal-calendar'));

// Seasonal Calendar routes
const seasonalCalendarRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'seasonal-calendar',
  component: () => (
    <AuthGuard
      splashScreen={<SplashScreen />}
      loginPath={paths.auth.jwt.login}
      pathOnAuthProblem={paths.auth.jwt.login}
    >
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AuthGuard>
  ),
});

const seasonalCalendarIndexRoute = createRoute({
  getParentRoute: () => seasonalCalendarRoute,
  path: '/',
  component: SeasonalCalendar,
});

export const seasonalCalendarRouteTree = seasonalCalendarRoute.addChildren([
  seasonalCalendarIndexRoute,
]);